const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Hiper24 = function Hiper24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "m4.351 6.758 11.216-2.675a3.068 3.068 0 0 1 3.684 2.276l2.666 11.25a3.07 3.07 0 0 1-.43 2.405H4.348l-2.266-9.56A3.078 3.078 0 0 1 4.35 6.757z",
      fill: "#E46C2A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.328 11.357v4.807h1.087v-2.011H7.2v2.011h1.08v-4.807H7.2v1.847H5.415v-1.847H4.328zM17.639 14.766c.014-.078.035-.242.035-.428 0-.863-.426-1.74-1.55-1.74-1.208 0-1.755.977-1.755 1.861 0 1.092.675 1.776 1.855 1.776.47 0 .903-.071 1.259-.214l-.143-.734c-.291.092-.59.142-.96.142-.504 0-.945-.214-.98-.663h2.239zm-2.247-.742c.029-.292.214-.706.669-.706.497 0 .611.443.611.706h-1.28zm2.629 2.14h1.08v-1.769c0-.085.008-.171.022-.242.07-.335.341-.55.74-.55.12 0 .213.015.29.03v-1.02c-.077-.015-.127-.015-.227-.015-.334 0-.76.214-.938.72h-.029l-.035-.641h-.932c.014.299.029.634.029 1.148v2.339z",
      fill: "#FFFFFE",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M9.38 11.164a.556.556 0 1 1-.002 1.113.556.556 0 0 1 .002-1.113z",
      fill: "#FFE80F",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M11.662 15.351h.542c.545 0 .791-.35.791-.714 0-.365-.026-1.19-.7-1.19-.772 0-.647 1.024-.644 1.56.001.115.008.23.01.345zm-2.838-2.68h1.111v1.966c0 .364.202.714.648.714.003-.884 0-1.795-.03-2.68h.928c.02.17.039.342.055.513.439-.88 1.82-.686 2.286.056.48.768.644 2.964-1.618 2.964h-.526c.005.446.006.892.006 1.339h-1.111c0-.429.002-.878.005-1.34-1.2-.003-1.754-.768-1.754-1.566v-1.965z",
      fill: "#FFFFFE",
    })
  );
};
Hiper24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Hiper24,
};
export function Hiper(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Hiper' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
